import React from "react";
import dayjs from "dayjs";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { DatePicker, Checkbox, Input, Button, Upload } from "antd";
import { 
    CenteredModal,
    StyledGroup, 
    ModalOverlay, 
    ModalButtons, 
    ModalHeader, 
    FormField, 
    InputField,
    StyledTextArea,
    CheckboxField, 
    WrapGroups
} from "./styles";
import MediaUploader from "./components/MediaUploader";
import MultiMediaUploader from "./components/MultiMediaUploader";

// Схема валидации через Yup
const validationSchema = Yup.object().shape({
  id: Yup.string().required("ID обязателен"),
  startDate: Yup.date().required("Дата начала обязательна"),
  name: Yup.string().min(5).required("Название обязательно"),
  desc: Yup.string().min(5).required("Описание обязательно"),
  drescode: Yup.boolean(),
  draft: Yup.boolean(),
  published: Yup.boolean(),
  phone: Yup.string()
    .matches(/^[+][0-9]{9,15}$/, "Введите корректный номер телефона")
    // .required("Телефон обязателен"),
});

const AfishaModal = ({ visible, onCancel, onSubmit, initialValues, shop }) => {
    if (!visible) return null;
    return (
        <>
        <ModalOverlay onClick={onCancel} /> {/* Задний фон */}
        <CenteredModal>
            <Formik
            initialValues={initialValues || {
                id: "",
                startDate: null,
                name: "",
                desс: "",
                drescode: false,
                draft: true,
                published: false,
                phone: "",
            }}
            validationSchema={validationSchema}
            onSubmit={(values) => onSubmit(values)}
            >
            {({ values, errors, touched, setFieldValue }) => (
                <Form>
                    {/* Заголовок */}
                    <ModalHeader>
                        {initialValues ? "Редактировать Событие" : "Создать новое Событие"}
                    </ModalHeader>

                    <WrapGroups>
                        <StyledGroup>
                            {/* ID */}
                            <InputField $hasError={!!(touched.id && errors.id)}>
                                <label htmlFor="id">ID</label>
                                <Input value={values.id} disabled />
                                {touched.id && errors.id && (
                                    <StyledErrorMessage name="id" />
                                )}
                            </InputField>
                            
                            {/* Дата начала */}
                            <FormField>
                                <label htmlFor="startDate">Дата начала</label>
                                <DatePicker
                                    format="DD.MM.YYYY"
                                    value={values.startDate ? dayjs(values.startDate) : null} // Преобразование строки ISO в объект dayjs
                                    onChange={(date) => setFieldValue("startDate", date ? date.toISOString() : null)} // Сохранение обратно в формате ISO 8601
                                    style={{ width: "100%" }}
                                />
                                {touched.startDate && errors.startDate && (
                                    <StyledErrorMessage name="startDate" />
                                )}
                            </FormField>

                            {/* Название */}
                            <InputField $hasError={!!(touched.name && errors.name)}>
                                <label htmlFor="name">Название</label>
                                <Input
                                name="name"
                                value={values.name}
                                onChange={(e) => setFieldValue("name", e.target.value)}
                                placeholder="Название события"
                                />
                                {touched.name && errors.name && (
                                    <StyledErrorMessage name="name" />
                                )}
                            </InputField>

                            {/* Телефон */}
                            {/* <InputField $hasError={!!(touched.phone && errors.phone)}>
                                <label htmlFor="phone">Телефон</label>
                                <Input
                                    name="phone"
                                    value={values.phone}
                                    onChange={(e) => setFieldValue("phone", e.target.value)}
                                    placeholder="+7 (XXX) XXX-XX-XX"
                                />
                                {touched.phone && errors.phone && (
                                    <StyledErrorMessage name="phone" />
                                )}
                            </InputField> */}
                        </StyledGroup>
                        <StyledGroup>
                            {/* Описание */}
                            <StyledTextArea $hasError={!!(touched.desc && errors.desc)}>
                                <label htmlFor="desc">Описание</label>
                                <Input.TextArea
                                    name="desc"
                                    value={values.desc}
                                    onChange={(e) => setFieldValue("desc", e.target.value)}
                                    placeholder="Описание события"
                                />
                                {touched.desc && errors.desc && (
                                    <StyledErrorMessage name="desc" />
                                )}
                            </StyledTextArea>
                        </StyledGroup>
                    </WrapGroups>
                    <WrapGroups>
                        <MultiMediaUploader 
                            values={values.media || []} 
                            setFieldValue={setFieldValue} 
                            eventData={values}
                            shop={shop}
                        />
                    </WrapGroups>
                    
                    <WrapGroups>
                        <StyledGroup>
                            <ModalButtons>
                                <CheckboxField>
                                    <Checkbox
                                        name="drescode"
                                        checked={values.drescode}
                                        onChange={(e) => setFieldValue("drescode", e.target.checked)}
                                    >
                                    Дресс-код
                                    </Checkbox>
                                </CheckboxField>

                                <CheckboxField>
                                    <Checkbox
                                        name="draft"
                                        checked={values.draft}
                                        onChange={(e) => setFieldValue("draft", e.target.checked)}
                                    >
                                    Черновик
                                    </Checkbox>
                                </CheckboxField>

                                <CheckboxField>
                                    <Checkbox
                                        name="published"
                                        checked={values.published}
                                        onChange={(e) => setFieldValue("published", e.target.checked)}
                                    >
                                    Опубликовано
                                    </Checkbox>
                                </CheckboxField>

                            </ModalButtons>
                            {/* Чекбоксы */}

                        </StyledGroup>
                        <StyledGroup>
                            {/* Кнопки */}
                            <ModalButtons>
                                <Button type="default" onClick={onCancel}>
                                    Отмена
                                </Button>
                                <Button type="primary" htmlType="submit">
                                    Сохранить
                                </Button>
                            </ModalButtons>

                        </StyledGroup>
                    </WrapGroups>
                </Form>
            )}
            </Formik>
        </CenteredModal>
        </>
  );
};

export default AfishaModal;

const StyledErrorMessage = ({ name }) => (
  <ErrorMessage
    name={name}
    render={(msg) => <div style={{ color: "red" }}>{msg}</div>}
  />
);
